export default "__VITE_ASSET__BkKwI5An__"